<template>
  <v-card
    v-if="hasRole('ROLE_SEMINAR_ADMIN')"
    class="mx mb-4"
  >
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <h3 class="font-weight-bold mb-3 black--text">
              {{ $t("DownloadSeminars") }}
            </h3>
            <p>
              {{ $t("DownloadSeminarsExplanation") }}
            </p>
          </v-col>
          <v-col
            cols="4"
            md="2"
            class="d-flex align-end"
          >
            <v-select
              :items="years"
              :label="$t('year')"
              v-model="selectedYear"
            />
          </v-col>
          <v-col
            cols="4"
            class="d-flex justify-start align-end pb-8"
          >
            <v-btn
              :disabled="downloadDisabled"
              outlined
              @click="downloadSeminars()"
            >
              <v-icon>mdi-download</v-icon>
              <span>{{ $t("Download") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
  import DocumentMixin from "@/mixins/DocumentMixin";
  import SeminarMixin from "@/mixins/SeminarMixin";
  import TenantMixin from "@/mixins/TenantMixin";

  export default {
    name: "SeminarDownloader",
    mixins: [DocumentMixin, SeminarMixin, TenantMixin],
    data() {
      return {
        years: Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - 4 + i),
        selectedYear: null,
      };
    },
    computed: {
      downloadDisabled() {
        return this.selectedYear === null;
      },
    },
    methods: {
      downloadSeminars() {
        const tenantName = this.activeTenant.name.toLowerCase().replace(/\s+/g, '-').trim();
        this.downloadDocument(
          `/seminars-csv-list?order[timeSlot.start]=asc&timeSlot.start[after]=${this.selectedYear}-01-01&timeSlot.start[before]=${this.selectedYear}-12-31`,
          `seminare_${tenantName}_${this.selectedYear}.csv`,
          true
        );
        this.selectedYear = null;
      },
    },
  };
</script>
